import React, { useState } from 'react';
import { CountdownTimer } from './CountdownTimer';
import { CheckIcon, StarIcon } from 'lucide-react';
const CHECKOUT_BASIC = 'https://checkout.recursodigital.shop/cart/41301282291770:1';
const CHECKOUT_INTERMEDIATE = 'https://checkout.recursodigital.shop/cart/41301282291770:1';
const CHECKOUT_COMPLETE = 'https://checkout.recursodigital.shop/cart/41301282291770:1';
type PackType = 'basic' | 'intermediate' | 'complete';
export function FinalCTA() {
  const [selectedPack, setSelectedPack] = useState<PackType>('complete');
  const getCheckoutUrl = () => {
    switch (selectedPack) {
      case 'basic':
        return CHECKOUT_BASIC;
      case 'intermediate':
        return CHECKOUT_INTERMEDIATE;
      case 'complete':
        return CHECKOUT_COMPLETE;
    }
  };
  return <section className="w-full bg-[#0a0a0a] py-12 md:py-16 px-4" data-id="element-83">
      <div className="max-w-3xl mx-auto" data-id="element-84">
        {/* Emotional opener */}
        <div className="text-center mb-8" data-id="element-85">
          <h2 className="text-3xl md:text-4xl font-black font-heading text-white mb-4" data-id="element-86">
            🧠 MEGAPACK TDAH EN RETROCESO
          </h2>
          <p className="text-lg md:text-xl text-gray-300 font-body mb-2" data-id="element-87">
            Puedes seguir probando cosas al azar…
          </p>
          <p className="text-xl md:text-2xl font-bold text-yellow-400 font-heading mb-2" data-id="element-88">
            O puedes tener un sistema claro desde hoy
          </p>
          <p className="text-lg md:text-xl text-white font-heading font-bold" data-id="element-89">
            👉 Acompañar a tu hijo sin gritos es posible
          </p>
        </div>

        {/* Countdown */}
        <div className="text-center mb-10" data-id="element-90">
          <p className="text-yellow-400 font-bold text-base mb-4 font-heading" data-id="element-91">
            ⏰ El precio de lanzamiento termina en:
          </p>
          <CountdownTimer data-id="element-92" />
        </div>

        {/* Pack Selector Title */}
        <div className="text-center mb-8" data-id="element-93">
          <h3 className="text-2xl md:text-3xl font-black font-heading text-white mb-2" data-id="element-94">
            Elige tu <span className="text-yellow-400" data-id="element-95">MegaPack:</span>
          </h3>
          <p className="text-gray-400 font-body" data-id="element-96">
            Todas las opciones incluyen los 3 bonos estratégicos
          </p>
        </div>

        <div className="space-y-4 mb-8" data-id="element-97">
          {/* Pack Básico */}
          <div onClick={() => setSelectedPack('basic')} className={`cursor-pointer rounded-2xl p-5 md:p-6 border-2 transition-all duration-300 flex items-center gap-4 ${selectedPack === 'basic' ? 'bg-gray-800 border-yellow-400 shadow-[0_0_20px_rgba(250,204,21,0.15)]' : 'bg-gray-900 border-gray-800 hover:border-gray-700'}`} data-id="element-98">
            <div className="flex-shrink-0" data-id="element-99">
              <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selectedPack === 'basic' ? 'border-yellow-400' : 'border-gray-500'}`} data-id="element-100">
                {selectedPack === 'basic' && <div className="w-3 h-3 rounded-full bg-yellow-400" data-id="element-101" />}
              </div>
            </div>
            <div className="flex-1 flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-102">
              <div data-id="element-103">
                <div className="flex items-center gap-2 mb-1" data-id="element-104">
                  <span className="text-xl" data-id="element-105">📘</span>
                  <h4 className="text-lg md:text-xl font-black font-heading text-white" data-id="element-106">
                    PACK BÁSICO
                  </h4>
                </div>
                <p className="text-sm md:text-base text-gray-400 font-body" data-id="element-107">
                  5 tomos + sistema completo + 3 bonos
                </p>
              </div>
              <div className="text-left md:text-right" data-id="element-108">
                <p className="text-sm text-gray-500 line-through font-body" data-id="element-109">
                  ARS 27.990
                </p>
                <p className="text-2xl md:text-3xl font-black font-heading text-white" data-id="element-110">
                  ARS 19.990
                </p>
              </div>
            </div>
          </div>

          {/* Pack Completo */}
          <div onClick={() => setSelectedPack('complete')} className={`cursor-pointer rounded-2xl p-5 md:p-6 border-2 transition-all duration-300 flex items-start md:items-center gap-4 ${selectedPack === 'complete' ? 'bg-gray-800 border-yellow-400 shadow-[0_0_20px_rgba(250,204,21,0.25)] scale-[1.02] md:scale-105 z-10 relative' : 'bg-gray-900 border-gray-800 hover:border-gray-700'}`} data-id="element-111">
            <div className="flex-shrink-0 mt-2 md:mt-0" data-id="element-112">
              <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selectedPack === 'complete' ? 'border-yellow-400' : 'border-gray-500'}`} data-id="element-113">
                {selectedPack === 'complete' && <div className="w-3 h-3 rounded-full bg-yellow-400" data-id="element-114" />}
              </div>
            </div>
            <div className="flex-1 flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-115">
              <div data-id="element-116">
                <div className="flex items-center gap-2 mb-2" data-id="element-117">
                  <span className="text-xl" data-id="element-118">🏆</span>
                  <h4 className="text-lg md:text-xl font-black font-heading text-white" data-id="element-119">
                    PACK COMPLETO
                  </h4>
                </div>
                <div className="flex flex-wrap gap-2 mb-3" data-id="element-120">
                  <span className="bg-yellow-400 text-black text-xs font-bold px-2 py-1 rounded flex items-center gap-1 font-heading" data-id="element-121">
                    <StarIcon className="w-3 h-3 fill-black" data-id="element-122" /> MÁS ELEGIDO
                  </span>
                  <span className="border border-yellow-600 text-yellow-500 text-xs font-bold px-2 py-1 rounded font-heading" data-id="element-123">
                    AHORRAS USD 7.90
                  </span>
                </div>
                <p className="text-sm md:text-base text-gray-400 font-body mb-2" data-id="element-124">
                  Todo lo anterior +
                </p>
                <ul className="space-y-1" data-id="element-125">
                  <li className="text-sm md:text-base text-gray-300 font-body flex items-start gap-2" data-id="element-126">
                    <CheckIcon className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" data-id="element-127" />
                    Crianza digital avanzada
                  </li>
                  <li className="text-sm md:text-base text-gray-300 font-body flex items-start gap-2" data-id="element-128">
                    <CheckIcon className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" data-id="element-129" />
                    Sistema de personalización y entorno familiar
                  </li>
                </ul>
              </div>
              <div className="text-left md:text-right mt-2 md:mt-0" data-id="element-130">
                <p className="text-sm text-gray-500 line-through font-body" data-id="element-131">
                  ARS 79.990
                </p>
                <p className="text-3xl md:text-4xl font-black font-heading text-yellow-400" data-id="element-132">
                  ARS 27.990
                </p>
              </div>
            </div>
          </div>

          {/* Pack Intermedio */}
          <div onClick={() => setSelectedPack('intermediate')} className={`cursor-pointer rounded-2xl p-5 md:p-6 border-2 transition-all duration-300 flex items-center gap-4 ${selectedPack === 'intermediate' ? 'bg-gray-800 border-yellow-400 shadow-[0_0_20px_rgba(250,204,21,0.15)]' : 'bg-gray-900 border-gray-800 hover:border-gray-700'}`} data-id="element-133">
            <div className="flex-shrink-0" data-id="element-134">
              <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selectedPack === 'intermediate' ? 'border-yellow-400' : 'border-gray-500'}`} data-id="element-135">
                {selectedPack === 'intermediate' && <div className="w-3 h-3 rounded-full bg-yellow-400" data-id="element-136" />}
              </div>
            </div>
            <div className="flex-1 flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-137">
              <div data-id="element-138">
                <div className="flex items-center gap-2 mb-1" data-id="element-139">
                  <span className="text-xl" data-id="element-140">📗</span>
                  <h4 className="text-lg md:text-xl font-black font-heading text-white" data-id="element-141">
                    PACK INTERMEDIO
                  </h4>
                </div>
                <p className="text-sm md:text-base text-gray-400 font-body" data-id="element-142">
                  Todo lo anterior + Manual completo de comunicación parental
                </p>
              </div>
              <div className="text-left md:text-right" data-id="element-143">
                <p className="text-sm text-gray-500 line-through font-body" data-id="element-144">
                  ARS 49.990
                </p>
                <p className="text-2xl md:text-3xl font-black font-heading text-white" data-id="element-145">
                  ARS 23.990
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <div className="mt-8" data-id="element-146">
          <a href={getCheckoutUrl()} className="block w-full bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-black md:text-2xl py-5 rounded-xl text-center transition-colors duration-200 cursor-pointer font-heading shadow-lg text-[18px]" data-id="element-147">
            👉 QUIERO MI MEGAPACK AHORA
          </a>

          <div className="flex flex-wrap justify-center gap-6 mt-6 text-sm md:text-base text-gray-400 font-body" data-id="element-148">
            <span className="flex items-center gap-1" data-id="element-149">🔒 Pago seguro</span>
            <span className="flex items-center gap-1" data-id="element-150">⚡ Acceso inmediato</span>
            <span className="flex items-center gap-1" data-id="element-151">🛡️ Garantía 7 días</span>
          </div>
        </div>

        {/* Emotional closer */}
        <div className="border-t border-gray-800 pt-8 mt-10 text-center" data-id="element-152">
          <p className="text-lg md:text-xl text-gray-300 font-body italic mb-4" data-id="element-153">
            Porque criar no debería sentirse como una batalla todos los días.
          </p>
          <p className="text-xl md:text-2xl font-bold text-yellow-400 font-heading" data-id="element-154">
            👉 Y ahora tienes un sistema para cambiar eso
          </p>
        </div>
      </div>
    </section>;
}